import { IDocumentGenerationRequest } from '@commenda/types/src/document-generation';
import { fetcher } from '@commenda/utils';

const DOCUMENT_GENERATION_REQUEST_BASE_URL = 'document-generation-request';

export const getDocumentGenerationRequest = async (
  documentGenerationRequestId: string
): Promise<{
  success: boolean;
  data: IDocumentGenerationRequest | null;
}> => {
  try {
    const res = await fetcher(
      `${DOCUMENT_GENERATION_REQUEST_BASE_URL}/${documentGenerationRequestId}`,
      {
        method: 'GET',
      }
    );
    if (!res.ok) {
      return {
        success: false,
        data: null,
      };
    }
    const responseData = (await res.json()) as IDocumentGenerationRequest;
    return {
      success: true,
      data: responseData,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
    };
  }
};
